import {CommonModule}               from "@angular/common";
import {FormsModule}                from '@angular/forms';
import {NgModule}                   from '@angular/core';
import {MomentModule}               from 'angular2-moment';
import {NgbModule}                  from '@ng-bootstrap/ng-bootstrap';
import {Ng4LoadingSpinnerModule}    from "ng4-loading-spinner";

import {ArticlesComponent}          from './articles.component';
import {ArticlesRoutingModule}      from "./articles.routing.module";
import {DatepickerRangeComponent}   from './feed/news/datepicker/datepicker-range.component';
import {DatepickerSingleComponent}  from './feed/news/datepicker-single/datepicker-single.component';
import {InactivesComponent}         from './inactives/inactives.component';
import {ItemComponent}              from './item/item.component';
import {ListComponent}              from './list/list.component';
import {NewsComponent}              from './feed/news/news.component';
import {NewsViewComponent}          from './feed/news/view/news-view.component';
import {OnlyLoggedInGuard}          from "../services/miscellaneous/only-logged-in.guard";
import {PreviewComponent}           from "./inactives/preview/inactives-preview.component";
import {RssmanagerComponent}        from './feed/rssmanager/rssmanager.component';
import {RssmanagerEditComponent}    from './feed/rssmanager/edit/rssmanager-edit.component';
import {SharedModule}               from "../shared.module";
import {SuperUserGuard}             from "../services/miscellaneous/super-user.guard";
import {UserReportingComponent}     from '../admin/users/user-reporting.component';
import {UserManagerComponent}       from "../admin/users/user-manager.component";
import {VersionComponent}           from "./version/version.component";


@NgModule({

	declarations: [

		ArticlesComponent,
		DatepickerRangeComponent,
		DatepickerSingleComponent,
		InactivesComponent,
		ItemComponent,
		ListComponent,
		NewsComponent,
		NewsViewComponent,
		PreviewComponent,
		RssmanagerComponent,
		RssmanagerEditComponent,
		UserReportingComponent,
		UserManagerComponent,
		VersionComponent,

	],
	imports: [

		CommonModule,
		FormsModule,
		MomentModule,
		NgbModule,
		SharedModule,
		Ng4LoadingSpinnerModule.forRoot(),
		ArticlesRoutingModule  // This module must always be last!

	],
	providers: [

		OnlyLoggedInGuard,
		SuperUserGuard,

	]

})


/**
 * This is the Module that manages all the imports
 * and declarations for the non-administrative
 * components.
 */
export class ArticlesModule {}



// WEBPACK FOOTER //
// ./src/app/articles/articles.module.ts